export default __webpack_public_path__ + "static/media/Bank_Central_Asia.159682c9.png";